import { Button, Text, View } from '@mirai/ui';
import React from 'react';
import { useLocation } from 'wouter';

import * as style from './routes.module.css';

export const NotFound = () => {
  const [, setLocation] = useLocation();

  return (
    <View tag="section" className={[style.section, style.border, style.home]}>
      <View className={[style.wrapper, style.centered]}>
        <Text bold className={style.slogan}>
          Oops! Something went wrong.
        </Text>
        <Text headline>Url {window.location.href} is not a valid.</Text>
        <Button preventDefault={false} onPress={() => setLocation('/')}>
          RETURN TO HOME →
        </Button>
      </View>
    </View>
  );
};
